import React, { useEffect, useState } from 'react';
import { Field as Fieldmik, FieldArray, Formik } from 'formik';
import { Form as FormUi, Input, Button, Dropdown, Grid, Header, Table, Icon, Segment } from 'semantic-ui-react';
import Axios from 'axios';
import moment from 'moment';

import { DateData } from '../formikInput/date';
import { MyInput, MyNormalInput } from '../formikInput/input';
import APP_CONSTANTS from '../../config/constants';
import ProductSKUDropdown from '../dropdowns/productSKUDropdown';
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder';



const AddProduct = ({ handleChange, billmode, poId, masterState, vendorStateId,
    isGstApplicable, formValues, updatePurchaseOrder, handleClose, isSubmitted, viewmode, masterBranch }) => {

    const [productData, setProductData] = useState([])
    const [purchaseOrderDetails, setPurchaseOrderDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo,
                "poId": poId
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}/purchase/purchaseorder/getPurchaseOrders`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setPurchaseOrderDetails(response.data.data).then(() => setIsLoading(false))
        }))
            .catch(error => console.log(error)).then(() => setIsLoading(false))
    }, [])

    const getProductData = childData => {
        setProductData(childData);
    }


    if (isLoading) {
        return <LoadingPlaceholder />
    } else if (purchaseOrderDetails && purchaseOrderDetails.length > 0) {

        let psLineItems = []

        purchaseOrderDetails && purchaseOrderDetails[0].po_details.map((po, index) => {
            let temp = {}
            temp.productName = po.productId
            temp.startDate = po.startDate === "0000-00-00" ? "" : new Date(po.startDate)
            temp.endDate = po.endDate === "0000-00-00" ? "" : new Date(po.endDate)
            temp.quantity = po.productQty
            temp.isAdditionalCharge = po.isAdditionalCharge
            temp.rate = Math.trunc(po.productPrice)
            temp.discount = Math.trunc(po.discount)
            temp.discountType = po.discountType
            temp.iGstPercent = Math.trunc(po.igstPercent)
            temp.iGst = ''
            temp.cGstPercent = Math.trunc(po.cgstPercent)
            temp.cGst = ''
            temp.sGstPercent = Math.trunc(po.sgstPercent)
            temp.sGst = ''
            temp.amount = ''

            psLineItems[index] = temp

        })

        const initialValues = {
            productDetails: psLineItems && psLineItems

        }


        const onSubmit = (values, onSubmitProps) => {

            const customerNumber = localStorage.getItem('customerNumber');
            const userId = localStorage.getItem('userId');

            let psLineItems = [];
            values.productDetails.map((product, index) => {
                let temp = {}
                temp.psCode = product.productCode
                temp.psName = product.productName
                temp.startDate = product.startDate
                temp.endDate = product.endDate
                temp.psQty = product.quantity
                temp.psPrice = product.rate
                temp.psAmount = product.rate * product.quantity
                temp.igstPercent = product.iGstPercent
                temp.isAdditionalCharge = product.isAdditionalCharge
                temp.igstAmount = product.iGst
                temp.cgstPercent = product.cGstPercent
                temp.cgstAmount = product.cGst
                temp.sgstPercent = product.sGstPercent
                temp.sgstAmount = product.sGst
                temp.tdsCode = 9
                temp.discount = product.discount
                temp.finalDiscount = product.discount
                temp.discountType = product.discountType
                temp.taxableAmount = product.rate * product.quantity - product.discount
                temp.totalAmount = product.amount

                psLineItems[index] = temp
            });

            const updateAdditionalCharges = {
                customerNo: customerNumber,
                userId: userId,
                poReferenceNo: purchaseOrderDetails[0].poReferenceNo,
                vendorCode: purchaseOrderDetails[0].vendorCode,
                branchCode: masterBranch,
                vendorBranchCode: formValues.vendorBranch,
                vehicleNo: purchaseOrderDetails[0].vehicleNo,
                poQuantity: psLineItems.length,
                poAmount: values.finalAmount,
                poNumber: purchaseOrderDetails[0].poNumber,
                sgstAmount: psLineItems.sum("sgstAmount"),
                cgstAmount: psLineItems.sum("cgstAmount"),
                igstAmount: psLineItems.sum("igstAmount"),
                adjustment: values.adjustmentAmount,
                remarks: '',
                gstTaxType: '',
                poDate: moment(purchaseOrderDetails[0].poDate).format('DD-MM-YYYY'),
                tdsAmount: '',
                taxableAmount: psLineItems.sum("taxableAmount"),
                totalDiscount: psLineItems.sum("discount"),
                totalOrderAmt: values.finalAmount,
                psDetails: psLineItems,
            }

            updatePurchaseOrder(updateAdditionalCharges, handleClose).then(() => {
                isSubmitted(true)
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });
        }

        return (
            <div className="ui form">
                <Formik
                    initialValues={initialValues}
                    onSubmit={onSubmit}>

                    <FieldArray
                        name="productDetails">
                        {({ push, remove, form }) => {

                            const { inititalValues, values, setFieldValue, isSubmitting, handleSubmit } = form
                            const { productDetails } = values


                            if (billmode == true) {
                                values.manualPoAddedTotal = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)
                                values.finalAmount = +values.activePoAddedTotal + +values.manualPoAddedTotal
                            }
                            else if (billmode == "view") {
                                values.finalAmount = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)
                            }
                            else {
                                values.finalAmount = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)
                            }
                            return (
                                <>
                                    <Table unstackable size="large" compact="very" className="w3-small">
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell className="w3-white" colSpan="8">  <label className="labelName w3-text-blue">Product/Service Details</label></Table.HeaderCell>
                                            </Table.Row>
                                            <Table.Row >
                                                <Table.HeaderCell className="labelName p-bold-600">Product Details</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">HSN/SAC Code</Table.HeaderCell>
                                                {/* <Table.HeaderCell className="labelName p-bold-600">Start Date</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">End Date</Table.HeaderCell> */}
                                                <Table.HeaderCell className="labelName p-bold-600">Quantity</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Rate</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Discount</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">IGST%</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">IGST(₹)</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">CGST</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">CGST(₹)</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">SGST</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">SGST(₹)</Table.HeaderCell>
                                                <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                                                <Table.HeaderCell textAlign="right" className="labelName p-bold-600">Delete</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                            {productDetails.map((object, index) => {

                                                const discountOptions = [
                                                    { key: '1', text: '₹', value: '1' },
                                                    { key: '2', text: '%', value: '2' },
                                                ];


                                                let tempAmount = '';
                                                if (object.discount > 0 && object.discountType == 1) {
                                                    let finalRate = +object.rate * +object.quantity
                                                    tempAmount = +finalRate - +object.discount
                                                } else {
                                                    let finalRate = +object.rate * +object.quantity
                                                    tempAmount = +finalRate - (+finalRate * +object.discount / 100)
                                                }

                                                if (object.productName) {
                                                    let addedProductObject = productData.filter(e => {
                                                        return e.psId === object.productName
                                                    })

                                                    if (addedProductObject && productData.length > 0) {

                                                        if (object.rate.length === 0) {
                                                            object.rate = addedProductObject ? +addedProductObject[0].sellingPrice : '';
                                                        }

                                                        object.hsnCode = addedProductObject && addedProductObject.length > 0 ? addedProductObject[0].HSNCode : '';
                                                        object.sacCode = addedProductObject && addedProductObject.length > 0 ? addedProductObject[0].SACCode : '';


                                                        if (isGstApplicable) {
                                                            if (vendorStateId === masterState) {
                                                                object.iGstPercent = addedProductObject[0].gstPercentage
                                                            } else {
                                                                object.cGstPercent = addedProductObject && addedProductObject[0].gstPercentage / 2
                                                                object.sGstPercent = addedProductObject && addedProductObject[0].gstPercentage / 2
                                                            }
                                                        } else {
                                                            object.cGstPercent = 0
                                                            object.sGstPercent = 0
                                                            object.iGstPercent = 0
                                                        }

                                                        object.productCode = addedProductObject && addedProductObject.length > 0 ? addedProductObject[0].psCode : ''

                                                    } else if (addedProductObject && productData.length > 0) {

                                                        object.productCode = addedProductObject[0].psCode
                                                    }
                                                }

                                                object.iGst = +object.iGstPercent / 100 * +tempAmount
                                                object.cGst = +object.cGstPercent / 100 * +tempAmount
                                                object.sGst = +object.sGstPercent / 100 * +tempAmount

                                                object.amount = +tempAmount + +object.iGst + +object.cGst + +object.sGst
                                                values.finalAmount = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)
                                                return (
                                                    <Table.Row verticalAlign="middle" key={index} >
                                                        <React.Fragment>
                                                            <Table.Cell>
                                                                <Fieldmik
                                                                    component={ProductSKUDropdown}
                                                                    getProductData={getProductData}
                                                                    placeholder="Product Name"
                                                                    name={`productDetails[${index}].productName`}
                                                                    style={{ width: '240px' }}
                                                                    value={object.productName ? object.productName : ''}
                                                                    disabled={object.isAdditionalCharge === 0 ? true : false}
                                                                />
                                                            </Table.Cell>
                                                            {/* <Table.Cell style={{ minWidth: '124px' }}>
                                                                <DateData
                                                                    name={`productDetails[${index}].startDate`}
                                                                    autoComplete="off"
                                                                    popperClassName="dateTime"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    placeholderText="Start Date"
                                                                    selected={productDetails[index].startDate}
                                                                    selectsStart
                                                                    startDate={productDetails[index].startDate}
                                                                    maxDate={productDetails[index]['endDate'] ? productDetails[index]['endDate'] : ''}
                                                                    endDate={productDetails[index]['endDate']}
                                                                    timeIntervals={5}
                                                                    customInput={<FormUi.Input error={productDetails[index].startDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell style={{ minWidth: '124px' }}>
                                                                <DateData
                                                                    name={`productDetails[${index}].endDate`}
                                                                    autoComplete="off"
                                                                    popperClassName="dateTime"
                                                                    dateFormat="dd-MM-yyyy"
                                                                    placeholderText="End Date"
                                                                    selected={productDetails[index].endDate}
                                                                    selectsStart
                                                                    startDate={productDetails[index].endDate}
                                                                    endDate={productDetails[index]['startDate']}
                                                                    minDate={productDetails[index]['startDate'] ? productDetails[index]['startDate'] : ''}
                                                                    timeIntervals={5}
                                                                    customInput={<FormUi.Input error={productDetails[index].endDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                                />
                                                            </Table.Cell> */}
                                                            <Table.Cell width={2}>{object.hsnCode || object.sacCode ? `${object.hsnCode, object.sacCode}` : ''}</Table.Cell>
                                                            <Table.Cell style={{ minWidth: '80px' }}>
                                                                <Fieldmik
                                                                    component={MyNormalInput}
                                                                    type="number"
                                                                    value={object.quantity === 0 ? '' : object.quantity}
                                                                    min="1"
                                                                    autoComplete="off"
                                                                    name={`productDetails[${index}].quantity`}
                                                                    size="small"
                                                                    disabled={object.isAdditionalCharge === 0 ? true : false}
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell style={{ minWidth: '90px' }}>
                                                                <Fieldmik
                                                                    component={MyNormalInput}
                                                                    type="number"
                                                                    min="0"
                                                                    value={object.rate === 0 ? 0 : object.rate}
                                                                    autoComplete="off"
                                                                    name={`productDetails[${index}].rate`}
                                                                    size="small"
                                                                    disabled={object.isAdditionalCharge === 0 ? true : false}
                                                                />
                                                            </Table.Cell>
                                                            <Table.Cell style={{ minWidth: '124px' }}>
                                                                <Fieldmik disabled={object.isAdditionalCharge === 0 ? true : false} style={{ width: '60%' }} type="number" component={MyNormalInput} value={object.discount === 0 ? 0 : object.discount} name={`productDetails[${index}].discount`} size="small"
                                                                    label={<Dropdown placeholder={object.discountType === 2 ? '%' : "₹"} options={discountOptions} defaultValue={object.discountType}
                                                                        onChange={(value, data) => object.discountType = data.value} />} labelPosition="right" className="tableinput" />
                                                            </Table.Cell>
                                                            <Table.Cell>{object.iGstPercent ? `${object.iGstPercent}%` : '0%'}</Table.Cell>
                                                            <Table.Cell>{object.iGst ? object.iGst.toFixed(2) : '0'}</Table.Cell>
                                                            <Table.Cell>{object.cGstPercent ? `${object.cGstPercent}%` : '0%'}</Table.Cell>
                                                            <Table.Cell>{object.cGst ? object.cGst.toFixed(2) : '0'}</Table.Cell>
                                                            <Table.Cell>{object.sGstPercent ? `${object.sGstPercent}%` : '0%'}</Table.Cell>
                                                            <Table.Cell>{object.sGst ? object.sGst.toFixed(2) : '0'}</Table.Cell>
                                                            <Table.Cell>{object.amount ? object.amount.toFixed(2) : '0'}</Table.Cell>
                                                            <Table.Cell hidden={index > 0 ? false : true} textAlign="right">
                                                                {object.isAdditionalCharge === 0 ?
                                                                    ""
                                                                    :
                                                                    <Button disabled={object.isAdditionalCharge === 0 ? true : false} onClick={() => remove(index)} type="button" basic size="mini" icon>
                                                                        <Icon className="overhere" color="red" name="trash" />
                                                                    </Button>
                                                                }

                                                            </Table.Cell>
                                                        </React.Fragment>

                                                    </Table.Row>
                                                )
                                            }
                                            )}
                                        </Table.Body>
                                    </Table>
                                    <Grid columns={3}>
                                        <Grid.Row className="p-2">
                                            <Grid.Column width={10}>
                                                {viewmode ? "" :
                                                    <Button className="ml-2" type="button" onClick={() => push({ productName: '', startDate: '', endDate: '', hsnCode: '', sacCode: '', isAdditionalCharge: 1, quantity: '', rate: '', discount: '', discountType: '1', iGstPercent: '', iGst: '', cGstPercent: '', cGst: '', sGstPercent: '', sGst: '', amount: '' })} size="mini" basic color="blue">
                                                        + Add Product
                                                </Button>}
                                            </Grid.Column>
                                            <Grid.Column>
                                                {/* {billmode ?
                                                    <>
                                                        <Grid.Row>
                                                            <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">New PO Total</Header>
                                                            <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.manualPoAddedTotal}</Header>
                                                        </Grid.Row>
                                                        <Grid.Row>
                                                            <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Active PO Total</Header>
                                                            <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.activePoAddedTotal}</Header>
                                                        </Grid.Row>
                                                    </>
                                                    :
                                                    ""
                                                } */}
                                                <Grid.Row>
                                                    <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Total</Header>
                                                    <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.finalAmount ? values.finalAmount : ''}</Header>
                                                </Grid.Row>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    {viewmode ? "" : <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>}

                                </>
                            )
                        }}

                    </FieldArray>

                </Formik>
            </div>
        )
    } else {
        return (
            <Segment>No Record(s) Found</Segment>
        )
    }

}

export default AddProduct










